import { Box, Button, TextField, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

interface IQuantityCellProps {
  bet: string;
  quantity: number;
  type: string;
  isDisabled: boolean;
  handleDecrement: (type: string, bet: string, quantity: number) => void;
  handleIncrement: (type: string, bet: string, quantity: number) => void;
  handleDelete: (type: string, bet: string) => void;
  handleQuantityChange: (e: React.ChangeEvent<HTMLInputElement>, type: string, bet: string) => void;
}

const QuantityCell = ({
  bet,
  quantity,
  type,
  isDisabled,
  handleDecrement,
  handleIncrement,
  handleDelete,
  handleQuantityChange,
}: IQuantityCellProps) => {
  const theme = useTheme();
  const [value, setValue] = useState(quantity.toString());

  useEffect(() => {
    setValue(quantity.toString());
  }, [quantity]);

  if (type === "imagePlaced" || type === "columnPlaced") return quantity;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #d2d2d2",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <Button
          sx={{
            width: theme.spacing(3),
            height: theme.spacing(3.25),
            borderRadius: 0,
          }}
          variant="contained"
          onClick={() => {
            handleDecrement(type, bet, quantity);
            setValue(quantity > 1 ? (quantity - 1).toString() : "1");
          }}
          disabled={quantity <= 1 || isDisabled}
        >
          <RemoveIcon sx={{ fontSize: (theme) => theme.typography.pxToRem(16) }} />
        </Button>

        <TextField
          sx={{
            "& fieldset": {
              border: "none",
            },
            "& input": {
              py: 0,
              px: 0.5,
              width: theme.spacing(3.5),
              minWidth: theme.spacing(3.5),
              height: theme.spacing(3.25),
              border: "none",
              "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              MozAppearance: "textfield",
            },
          }}
          size="small"
          type="text"
          inputMode="numeric"
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = e.target.value.replace(/[^0-9]/g, "");
            handleQuantityChange(e, type, bet);
            setValue(newValue);
          }}
          onBlur={() => {
            setValue(quantity.toString());
          }}
          disabled={isDisabled}
        />
        <Button
          sx={{
            width: theme.spacing(3),
            height: theme.spacing(3.25),
            borderRadius: 0,
          }}
          variant="contained"
          onClick={() => {
            handleIncrement(type, bet, quantity);
            setValue((quantity + 1).toString());
          }}
          disabled={isDisabled}
        >
          <AddIcon sx={{ fontSize: (theme) => theme.typography.pxToRem(16) }} />
        </Button>
      </Box>
      <Button
        sx={{
          width: theme.spacing(3),
          height: theme.spacing(3.25),
          borderRadius: 1,
        }}
        variant="contained"
        onClick={() => handleDelete(type, bet)}
        disabled={isDisabled}
        color="error"
        disableElevation
      >
        <DeleteOutlinedIcon sx={{ fontSize: (theme) => theme.typography.pxToRem(16) }} />
      </Button>
    </Box>
  );
};

export default QuantityCell;
